document.addEventListener('DOMContentLoaded', () => {

  // Initialize the dataLayer if it doesn't exist yet
  window.dataLayer = window.dataLayer || [];

  // ==========================================
  // 1. Header Logo Click Tracking
  // ==========================================
  const logoLink = document.querySelector('.header-logo');

  if (logoLink) {
    // Use capture phase (true) to ensure the event fires before navigation
    logoLink.addEventListener('click', function(e) {
      
      // Desktop only check
      if (window.innerWidth < 990) return; 

      try {
        const navItem = 'logo';
        const navLevel = 'primary';
        const elementLocation = 'header';

        // Console Debugging (Active for testing)
        console.group('🏠 GA4 Custom Event: nav_click (Logo)');
        console.log('%cNav Item:', 'color: #8e44ad; font-weight: bold;', navItem);
        console.log('%cLocation:', 'color: #8e44ad;', elementLocation);
        console.groupEnd();

        // DataLayer Push
        window.dataLayer.push({ ecommerce: null }); // Best practice to clear if preceding ecommerce events
        window.dataLayer.push({
          event: 'nav_click',
          nav_item: navItem,
          nav_level: navLevel,
          element_location: elementLocation
        });

        // Success Badge
        console.log('%c✅ SUCCESS: GA4 "nav_click" (logo) fired!', 'background: #8e44ad; color: #fff; padding: 2px 5px;');

      } catch (err) {
        console.error('❌ GA4 nav_click (logo) Error:', err);
      }
    }, true);
  }

  // ==========================================
  // 2. Primary Navigation Click Tracking
  // ==========================================
  const navLinks = document.querySelectorAll('.nav-link');

  if (navLinks.length > 0) {
    navLinks.forEach(link => {
      // Use capture phase (true)
      link.addEventListener('click', function(e) {
        
        // Desktop only check
        if (window.innerWidth < 990) return;

        try {
          // Dynamically grab the text of the link
          const navItem = this.innerText.trim();
          const navLevel = 'primary';
          const elementLocation = 'header';
  
          // Console Debugging
          console.group(`🧭 GA4 Custom Event: nav_click (${navItem})`);
          console.log('%cNav Item:', 'color: #2980b9; font-weight: bold;', navItem);
          console.log('%cLocation:', 'color: #2980b9;', elementLocation);
          console.groupEnd();
  
          // DataLayer Push
          window.dataLayer.push({ ecommerce: null }); 
          window.dataLayer.push({
            event: 'nav_click',
            nav_item: navItem,
            nav_level: navLevel,
            element_location: elementLocation
          });
  
          // Success Badge
          console.log(`%c✅ SUCCESS: GA4 "nav_click" (${navItem}) fired!`, 'background: #2980b9; color: #fff; padding: 2px 5px;');
  
        } catch (err) {
          console.error('❌ GA4 nav_click (Primary Nav) Error:', err);
        }
      }, true);
    });
  }

  // ==========================================
  // 3. Mobile Hamburger Menu Open Tracking
  // ==========================================
  // Targeting both the class and ID to be bulletproof
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle, #MobileMenuToggle');

  if (mobileMenuToggle) {
    // Use capture phase (true)
    mobileMenuToggle.addEventListener('click', function(e) {
      
      // Mobile only check (stops execution if screen is 990px or wider)
      if (window.innerWidth >= 990) return;

      try {
        const elementLocation = 'header';

        // Console Debugging
        console.group('🍔 GA4 Custom Event: menu_open');
        console.log('%cLocation:', 'color: #e67e22;', elementLocation);
        console.groupEnd();

        // DataLayer Push
        window.dataLayer.push({ ecommerce: null }); 
        window.dataLayer.push({
          event: 'menu_open',
          element_location: elementLocation
        });

        // Success Badge
        console.log('%c✅ SUCCESS: GA4 "menu_open" fired!', 'background: #e67e22; color: #fff; padding: 2px 5px;');

      } catch (err) {
        console.error('❌ GA4 menu_open Error:', err);
      }
    }, true);
  }


  // ==========================================
  // 4. Mobile Sidebar Navigation Click Tracking
  // ==========================================
  const mobileNavLinks = document.querySelectorAll('.mobile-nav-link');

  if (mobileNavLinks.length > 0) {
    mobileNavLinks.forEach(link => {
      // Use capture phase (true)
      link.addEventListener('click', function(e) {
        
        // Mobile only check (stops execution if screen is 990px or wider)
        if (window.innerWidth >= 990) return;

        try {
          // Dynamically grab the text of the link
          const navItem = this.innerText.trim();
          const navLevel = 'primary';
          const elementLocation = 'mobile_sidebar';
  
          // Console Debugging
          console.group(`📱 GA4 Custom Event: nav_click (Mobile: ${navItem})`);
          console.log('%cNav Item:', 'color: #16a085; font-weight: bold;', navItem);
          console.log('%cLocation:', 'color: #16a085;', elementLocation);
          console.groupEnd();
  
          // DataLayer Push
          window.dataLayer.push({ ecommerce: null }); 
          window.dataLayer.push({
            event: 'nav_click',
            nav_item: navItem,
            nav_level: navLevel,
            element_location: elementLocation
          });
  
          // Success Badge
          console.log(`%c✅ SUCCESS: GA4 "nav_click" (Mobile: ${navItem}) fired!`, 'background: #16a085; color: #fff; padding: 2px 5px;');
  
        } catch (err) {
          console.error('❌ GA4 nav_click (Mobile Nav) Error:', err);
        }
      }, true);
    });
  }


  // ==========================================
  // 5. Hero CTA Buttons Click Tracking------------------------------------------- 5 and 19 is merged in 19 
  // ==========================================
  // Selects any button that lives inside the .hero-buttons container
  const heroButtons = document.querySelectorAll('.hero-buttons .btn-custom');

  if (heroButtons.length > 0) {
    heroButtons.forEach(button => {
      // Use capture phase (true)
      button.addEventListener('click', function(e) {
        try {
          // Target just the front text to avoid the duplicated animation text
          const textElement = this.querySelector('.btn-text-front');
          
          // Fallback to the whole button text just in case the span is missing
          const buttonText = textElement ? textElement.innerText.trim() : this.innerText.trim();
          
          const elementLocation = 'hero';

          const eventName = window.location.pathname.split('/').pop() == 'glace-tour' ? "book_tour_click" : 'click_cta'
  
          // Console Debugging
          console.group(`🎯 GA4 Custom Event: (${eventName}) (${buttonText})`);
          console.log('%cElement Text:', 'color: #e74c3c; font-weight: bold;', buttonText);
          console.log('%cLocation:', 'color: #e74c3c;', elementLocation);
          console.groupEnd();
  
          // DataLayer Push
          window.dataLayer.push({ ecommerce: null }); 
          window.dataLayer.push({
            event: eventName,
            element_text: buttonText,
            element_location: elementLocation
          });
  
          // Success Badge
          console.log(`%c✅ SUCCESS: GA4 (${eventName}) (${buttonText}) fired!`, 'background: #e74c3c; color: #fff; padding: 2px 5px;');
  
        } catch (err) {
          console.error('❌ GA4 %c (Hero) Error:', eventName, err);
        }
      }, true);
    });
  }


  // ==========================================
  // 6. 'See Glacē In Action' Video Button Tracking
  // ==========================================
  const videoButton = document.querySelector('.js-open-video-modal');

  if (videoButton) {
    // Use capture phase (true)
    videoButton.addEventListener('click', function(e) {
      try {
        // Dynamically grab the button text and clean it up
        // We use innerText to get the text label while ignoring the SVG
        const buttonText = this.innerText.trim();
        const elementLocation = 'steps_section';

        // Console Debugging
        console.group(`🎬 GA4 Custom Event: click_cta (${buttonText})`);
        console.log('%cElement Text:', 'color: #27ae60; font-weight: bold;', buttonText);
        console.log('%cLocation:', 'color: #27ae60;', elementLocation);
        console.groupEnd();

        // DataLayer Push
        window.dataLayer.push({ ecommerce: null }); 
        window.dataLayer.push({
          event: 'click_cta',
          element_text: buttonText, // Dynamic text from button
          element_location: elementLocation
        });

        // Success Badge
        console.log(`%c✅ SUCCESS: GA4 "click_cta" (${buttonText}) fired!`, 'background: #27ae60; color: #fff; padding: 2px 5px;');

      } catch (err) {
        console.error('❌ GA4 click_cta (Video Button) Error:', err);
      }
    }, true);
  }

  // ==========================================
  // 7. Video Start Tracking (HTML5)
  // ==========================================
  const videoElement = document.querySelector('.js-modal-video-element');

  if (videoElement) {
    // Flag to ensure the event only fires on the FIRST play
    let videoPlayed = false;

    videoElement.addEventListener('play', function() {
      if (!videoPlayed) {
        try {
          const videoName = 'Glacē In Action';
          const videoId = 'glace_in_action_modal';
          const elementLocation = 'steps_section';

          // Console Debugging
          console.group(`🎥 GA4 Custom Event: video_start (${videoName})`);
          console.log('%cVideo Name:', 'color: #9b59b6; font-weight: bold;', videoName);
          console.log('%cLocation:', 'color: #9b59b6;', elementLocation);
          console.groupEnd();

          // DataLayer Push
          window.dataLayer.push({ ecommerce: null }); 
          window.dataLayer.push({
            event: 'video_start',
            video_name: videoName,
            video_id: videoId,
            element_location: elementLocation
          });

          // Success Badge
          console.log(`%c✅ SUCCESS: GA4 "video_start" (${videoName}) fired!`, 'background: #9b59b6; color: #fff; padding: 2px 5px;');

          // Set flag to true so this logic doesn't run again
          videoPlayed = true;

        } catch (err) {
          console.error('❌ GA4 video_start Error:', err);
        }
      }
    });
  }


  // ==========================================
  // 8. Video Progress Tracking (25%, 50%, 75%)
  // ==========================================
  const videoElementProgress = document.querySelector('.js-modal-video-element');

  if (videoElementProgress) {
    // We use a Set to track milestones we have already fired
    const milestonesReached = new Set();

    videoElementProgress.addEventListener('timeupdate', function() {
      if (this.duration > 0) {
        const percentComplete = (this.currentTime / this.duration) * 100;
        let milestone = null;

        // Determine which milestone we just passed
        if (percentComplete >= 75) milestone = 75;
        else if (percentComplete >= 50) milestone = 50;
        else if (percentComplete >= 25) milestone = 25;

        // If we found a milestone and haven't tracked it yet, push to dataLayer
        if (milestone && !milestonesReached.has(milestone)) {
          try {
            const videoName = 'Glacē In Action';
            const elementLocation = 'steps_section';

            // Console Debugging
            console.group(`📈 GA4 Custom Event: video_progress (${milestone}%)`);
            console.log('%cPercent:', 'color: #3498db; font-weight: bold;', milestone + '%');
            console.groupEnd();

            // DataLayer Push
            window.dataLayer.push({ ecommerce: null }); 
            window.dataLayer.push({
              event: 'video_progress',
              video_name: videoName,
              video_percent: milestone,
              element_location: elementLocation
            });

            // Success Badge
            console.log(`%c✅ SUCCESS: GA4 "video_progress" (${milestone}%) fired!`, 'background: #3498db; color: #fff; padding: 2px 5px;');

            // Mark as reached so it doesn't fire again
            milestonesReached.add(milestone);

          } catch (err) {
            console.error('❌ GA4 video_progress Error:', err);
          }
        }
      }
    });
  }


  // ==========================================
  // 9. Video Complete Tracking (90% or 'ended')
  // ==========================================
  const videoElementComplete = document.querySelector('.js-modal-video-element');

  if (videoElementComplete) {
    // Flag to ensure the event only fires once
    let videoCompleted = false;

    const fireCompleteEvent = () => {
      if (!videoCompleted) {
        try {
          const videoName = 'Glacē In Action';
          const elementLocation = 'steps_section';

          // Console Debugging
          console.group(`🏁 GA4 Custom Event: video_complete`);
          console.log('%cVideo Name:', 'color: #c0392b; font-weight: bold;', videoName);
          console.groupEnd();

          // DataLayer Push
          window.dataLayer.push({ ecommerce: null }); 
          window.dataLayer.push({
            event: 'video_complete',
            video_name: videoName,
            element_location: elementLocation
          });

          // Success Badge
          console.log(`%c✅ SUCCESS: GA4 "video_complete" fired!`, 'background: #c0392b; color: #fff; padding: 2px 5px;');

          videoCompleted = true;
        } catch (err) {
          console.error('❌ GA4 video_complete Error:', err);
        }
      }
    };

    // Trigger 1: Listen for the 'ended' event
    videoElementComplete.addEventListener('ended', fireCompleteEvent, true);

    // Trigger 2: Listen for 90% progress via 'timeupdate'
    videoElementComplete.addEventListener('timeupdate', function() {
      if (!videoCompleted && this.duration > 0) {
        const percentComplete = (this.currentTime / this.duration) * 100;
        if (percentComplete >= 90) {
          fireCompleteEvent();
        }
      }
    }, true);
  }


  // ==========================================
  // 10. Carousel Interaction Tracking (Fixed Indexing)
  // ==========================================
  const navButtons = document.querySelectorAll('.slider-nav-btn');

  if (navButtons.length > 0) {
    navButtons.forEach(btn => {
      // Set to 'false' (bubble phase) to avoid blocking the slider's native click scripts
      btn.addEventListener('click', function() {
        const action = this.classList.contains('nav-next') ? 'next' : 'prev';

        // Wait 150ms to allow the carousel JS to finish sliding and update DOM classes
        setTimeout(() => {
          try {
            // Target all slide items (checks both typical class names you might be using)
            const allSlides = Array.from(document.querySelectorAll('.slide-item, .before-after-slide'));
            
            if (allSlides.length === 0) return;

            // Search for the newly active slide
            const activeSlide = document.querySelector(
              '.slide-item.is-active, .slide-item.active, ' +
              '.before-after-slide.is-active, .before-after-slide.active'
            );

            let currentIndex = 0;

            if (activeSlide) {
              // Priority 1: Try reading a data-index attribute if your slider generates one
              const rawIndex = activeSlide.getAttribute('data-index');
              if (rawIndex !== null && rawIndex !== '') {
                currentIndex = parseInt(rawIndex, 10) + 1; 
              } else {
                // Priority 2: Fallback to structural position in the DOM (1-based)
                currentIndex = allSlides.indexOf(activeSlide) + 1;
              }
            }

            // Failsafe: Ensure we never pass 0, NaN, or negative numbers to GA4
            if (isNaN(currentIndex) || currentIndex < 1) {
              console.warn('⚠️ GA4: Could not accurately determine slide index. Defaulting to 1.');
              currentIndex = 1;
            }

            // Console Debugging
            console.group(`🔄 GA4 Custom Event: carousel_interact (${action})`);
            console.log('%cAction:', 'color: #f39c12; font-weight: bold;', action);
            console.log('%cIndex:', 'color: #f39c12; font-weight: bold;', currentIndex);
            console.groupEnd();

            // DataLayer Push
            window.dataLayer.push({ ecommerce: null }); 
            window.dataLayer.push({
              event: 'carousel_interact',
              carousel_section: 'before_after_results',
              carousel_action: action,
              carousel_index: currentIndex
            });

            // Success Badge
            console.log(`%c✅ SUCCESS: GA4 "carousel_interact" (${action}) fired! Index: ${currentIndex}`, 'background: #f39c12; color: #fff; padding: 2px 5px;');

          } catch (err) {
            console.error('❌ GA4 carousel_interact Error:', err);
          }
        }, 150); // Delay gives the slider time to assign the active class
      }, false);
    });
  }


  // ==========================================
  // 11. Before/After Slider Interaction Tracking
  // ==========================================
  const baInputs = document.querySelectorAll('.ba-range-input');
  const interactedSlides = new Set(); // Stores indices of slides already tracked

  if (baInputs.length > 0) {
    baInputs.forEach(input => {
      // Use capture phase (true)
      input.addEventListener('input', function() {
        try {
          // Find the parent slide item to get the data-index
          const parentSlide = this.closest('.slide-item');
          if (!parentSlide) return;

          const rawIndex = parentSlide.getAttribute('data-index');
          // Add 1 to make it 1-based as requested
          const slideIndex = parseInt(rawIndex) + 1;

          // If we haven't tracked this slide yet, push to dataLayer
          if (!interactedSlides.has(slideIndex)) {
            const elementLocation = 'results_slider';

            // Console Debugging
            console.group(`✨ GA4 Custom Event: before_after_interact`);
            console.log('%cSlide Index:', 'color: #9b59b6; font-weight: bold;', slideIndex);
            console.groupEnd();

            // DataLayer Push
            window.dataLayer.push({ ecommerce: null }); 
            window.dataLayer.push({
              event: 'before_after_interact',
              slide_index: slideIndex,
              element_location: elementLocation
            });

            // Success Badge
            console.log(`%c✅ SUCCESS: GA4 "before_after_interact" (Slide ${slideIndex}) fired!`, 'background: #9b59b6; color: #fff; padding: 2px 5px;');

            // Mark as interacted so it doesn't fire again
            interactedSlides.add(slideIndex);
          }
        } catch (err) {
          console.error('❌ GA4 before_after_interact Error:', err);
        }
      }, true);
    });
  }


  // ==========================================
  // 12. Quiz Start Tracking (First Question)
  // ==========================================
  const firstSlideOptions = document.querySelectorAll('.quiz-slide[data-index="0"] .quiz-option');

  if (firstSlideOptions.length > 0) {
    let quizStarted = false; // Flag to ensure it only fires once

    firstSlideOptions.forEach(option => {
      // Use capture phase (true)
      option.addEventListener('click', function() {
        if (!quizStarted) {
          try {
            const quizId = 'skin_quiz';

            // Console Debugging
            console.group('🧠 GA4 Custom Event: quiz_start');
            console.log('%cQuiz ID:', 'color: #34495e; font-weight: bold;', quizId);
            console.groupEnd();

            // DataLayer Push
            window.dataLayer.push({ ecommerce: null }); 
            window.dataLayer.push({
              event: 'quiz_start',
              quiz_id: quizId
            });

            // Success Badge
            console.log('%c✅ SUCCESS: GA4 "quiz_start" fired!', 'background: #34495e; color: #fff; padding: 2px 5px;');

            // Lock the flag so it cannot fire again during this session
            quizStarted = true;

          } catch (err) {
            console.error('❌ GA4 quiz_start Error:', err);
          }
        }
      }, true);
    });
  }

  // ==========================================
  // 13. Quiz Progress & Completion Tracking
  // ==========================================
  const nextButtons = document.querySelectorAll('.btn-next-question');

  if (nextButtons.length > 0) {
    nextButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        try {
          // Find the active slide containing this button
          const currentSlide = this.closest('.quiz-slide');
          if (!currentSlide) return;

          const slideIndex = parseInt(currentSlide.getAttribute('data-index'));
          const quizStep = slideIndex + 1; // 1-based step
          
          // Find the selected option within this specific slide
          const selectedOption = currentSlide.querySelector('.quiz-option.is-selected .option-label');
          const quizSelection = selectedOption ? selectedOption.innerText.trim() : 'No Selection';

          // Console Debugging
          console.group(`⏭️ GA4 Custom Event: quiz_progress (Step ${quizStep})`);
          console.log('%cSelection:', 'color: #2c3e50; font-weight: bold;', quizSelection);
          console.groupEnd();

          // DataLayer Push: Progress Event
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'quiz_progress',
            quiz_id: 'skin_quiz',
            quiz_step: quizStep,
            quiz_selection: quizSelection
          });

          // Check if this is the last step (index 2 corresponds to the 3rd question)
          if (slideIndex === 2) {
            console.log('%c🏁 GA4 Custom Event: quiz_complete', 'color: #2c3e50; font-weight: bold;');
            window.dataLayer.push({
              event: 'quiz_complete',
              quiz_id: 'skin_quiz'
            });
          }

          // Success Badge
          console.log(`%c✅ SUCCESS: GA4 "quiz_progress" (Step ${quizStep}) fired!`, 'background: #2c3e50; color: #fff; padding: 2px 5px;');

        } catch (err) {
          console.error('❌ GA4 quiz_progress Error:', err);
        }
      }, true);
    });
  }


  // ==========================================
  // 14. Quiz Final CTA Button Tracking
  // ==========================================
  const quizFinalBtn = document.querySelector('.btn-final');

  if (quizFinalBtn) {
    // Use capture phase (true)
    quizFinalBtn.addEventListener('click', function() {
      try {
        // Target just the front text to avoid the duplicated animation text
        const textElement = this.querySelector('.quiz-btn-barrel-text-front');
        const buttonText = textElement ? textElement.innerText.trim() : this.innerText.trim();
        const elementLocation = 'skin_quiz';

        // Console Debugging
        console.group(`🎯 GA4 Custom Event: click_cta (${buttonText})`);
        console.log('%cElement Text:', 'color: #e74c3c; font-weight: bold;', buttonText);
        console.log('%cLocation:', 'color: #e74c3c;', elementLocation);
        console.groupEnd();

        // DataLayer Push
        window.dataLayer.push({ ecommerce: null }); 
        window.dataLayer.push({
          event: 'click_cta',
          element_text: buttonText,
          element_location: elementLocation
        });

        // Success Badge
        console.log(`%c✅ SUCCESS: GA4 "click_cta" (${buttonText}) fired!`, 'background: #e74c3c; color: #fff; padding: 2px 5px;');

      } catch (err) {
        console.error('❌ GA4 click_cta (Quiz Final) Error:', err);
      }
    }, true);
  }


  // ==========================================
  // 15. Testimonial Stats CTA Button Tracking
  // ==========================================
  const testiBtn = document.querySelector('.glace-testi-btn');

  if (testiBtn) {
    // Use capture phase (true)
    testiBtn.addEventListener('click', function() {
      try {
        // Target just the front text to avoid the duplicated animation text
        const textElement = this.querySelector('.glace-testi-btn-front');
        const buttonText = textElement ? textElement.innerText.trim() : this.innerText.trim();
        const elementLocation = 'testimonial_stats';

        // Console Debugging
        console.group(`🎯 GA4 Custom Event: click_cta (${buttonText})`);
        console.log('%cElement Text:', 'color: #e74c3c; font-weight: bold;', buttonText);
        console.log('%cLocation:', 'color: #e74c3c;', elementLocation);
        console.groupEnd();

        // DataLayer Push
        window.dataLayer.push({ ecommerce: null }); 
        window.dataLayer.push({
          event: 'click_cta',
          element_text: buttonText,
          element_location: elementLocation
        });

        // Success Badge
        console.log(`%c✅ SUCCESS: GA4 "click_cta" (${buttonText}) fired!`, 'background: #e74c3c; color: #fff; padding: 2px 5px;');

      } catch (err) {
        console.error('❌ GA4 click_cta (Testimonial) Error:', err);
      }
    }, true);
  }


  // ==========================================
  // 16. Tour Buttons Click Tracking (Corrected)
  // ==========================================
  // const tourButtons = document.querySelectorAll('.tour-buttons .btn-barrel');

  // if (tourButtons.length > 0) {
  //   tourButtons.forEach((button, index) => {
  //     // Use capture phase (true)
  //     button.addEventListener('click', function() {
  //       try {
  //         // Target just the front text
  //         const textElement = this.querySelector('.btn-barrel-text-front');
  //         const buttonText = textElement ? textElement.innerText.trim() : this.innerText.trim();
  //         const elementLocation = 'tour_section';

  //         // Determine the correct event name based on the button index or text
  //         // Button 1 (index 0) uses 'book_tour_click', Button 2 (index 1) uses 'click_cta'
  //         const eventName = (index === 0) ? 'book_tour_click' : 'click_cta';

  //         // Console Debugging
  //         console.group(`🎯 GA4 Custom Event: ${eventName} (${buttonText})`);
  //         console.log('%cEvent Name:', 'color: #e74c3c; font-weight: bold;', eventName);
  //         console.log('%cElement Text:', 'color: #e74c3c;', buttonText);
  //         console.log('%cLocation:', 'color: #e74c3c;', elementLocation);
  //         console.groupEnd();

  //         // DataLayer Push
  //         window.dataLayer.push({ ecommerce: null }); 
  //         window.dataLayer.push({
  //           event: eventName,
  //           element_text: buttonText,
  //           element_location: elementLocation
  //         });

  //         // Success Badge
  //         console.log(`%c✅ SUCCESS: GA4 "${eventName}" (${buttonText}) fired!`, 'background: #e74c3c; color: #fff; padding: 2px 5px;');

  //       } catch (err) {
  //         console.error('❌ GA4 tour_section Error:', err);
  //       }
  //     }, true);
  //   });
  // }


  // ==========================================
  // 17. FAQ Accordion Expansion Tracking
  // ==========================================
  const faqButtons = document.querySelectorAll('.faq-question');

  if (faqButtons.length > 0) {
    faqButtons.forEach(button => {
      // Use capture phase (true)
      button.addEventListener('click', function() {
        try {
          // Check if it's currently closed (aria-expanded === 'false')
          // If it's false, the user is ABOUT to open it
          const isExpanding = this.getAttribute('aria-expanded') === 'false';

          if (isExpanding) {
            const questionText = this.querySelector('span') ? this.querySelector('span').innerText.trim() : this.innerText.trim();
            const elementLocation = 'faq_section';

            // Console Debugging
            console.group(`💬 GA4 Custom Event: faq_expand (${questionText})`);
            console.log('%cQuestion:', 'color: #9b59b6; font-weight: bold;', questionText);
            console.log('%cLocation:', 'color: #9b59b6;', elementLocation);
            console.groupEnd();

            // DataLayer Push
            window.dataLayer.push({ ecommerce: null }); 
            window.dataLayer.push({
              event: 'faq_expand',
              element_text: questionText,
              element_location: elementLocation
            });

            // Success Badge
            console.log(`%c✅ SUCCESS: GA4 "faq_expand" (${questionText}) fired!`, 'background: #9b59b6; color: #fff; padding: 2px 5px;');
          }

        } catch (err) {
          console.error('❌ GA4 faq_expand Error:', err);
        }
      }, true);
    });
  }


  // ==========================================
  // 18. Footer Logo Click Tracking
  // ==========================================
  const footerLogoLink = document.querySelector('.footer-logo-link');

  if (footerLogoLink) {
    // Use capture phase (true) to ensure the event fires before navigation
    footerLogoLink.addEventListener('click', function() {
      try {
        const navItem = 'logo';
        const navLevel = 'footer';
        const elementLocation = 'footer';

        // Console Debugging
        console.group('🏠 GA4 Custom Event: nav_click (Footer Logo)');
        console.log('%cNav Item:', 'color: #7f8c8d; font-weight: bold;', navItem);
        console.log('%cLevel:', 'color: #7f8c8d;', navLevel);
        console.log('%cLocation:', 'color: #7f8c8d;', elementLocation);
        console.groupEnd();

        // DataLayer Push
        window.dataLayer.push({ ecommerce: null }); 
        window.dataLayer.push({
          event: 'nav_click',
          nav_item: navItem,
          nav_level: navLevel,
          element_location: elementLocation
        });

        // Success Badge
        console.log('%c✅ SUCCESS: GA4 "nav_click" (footer logo) fired!', 'background: #7f8c8d; color: #fff; padding: 2px 5px;');

      } catch (err) {
        console.error('❌ GA4 footer_logo_click Error:', err);
      }
    }, true);
  }


  // ==========================================
  // 19. Tour Section Buttons (Fixes Double-Fire & Location)
  // ==========================================
  // Target the specific buttons inside the tour section
  // const tourSectionButtons = document.querySelectorAll('.tour-buttons .btn-barrel');

  // if (tourSectionButtons.length > 0) {
  //   tourSectionButtons.forEach(button => {
  //     button.addEventListener('click', function(e) {
  //       try {
  //         // 1. PREVENT DOUBLE FIRING: Stop generic trackers from reading this click
  //         e.stopImmediatePropagation();

  //         // 2. Get the specific text from your HTML structure
  //         const textElement = this.querySelector('.btn-barrel-text-front');
  //         const buttonText = textElement ? textElement.innerText.trim() : this.innerText.trim();
          
  //         // 3. SET FIXED LOCATION: Applies to both buttons as requested
  //         const elementLocation = 'tour_section'; 

  //         // 4. DETERMINE EVENT BY TEXT (Since the URL changed)
  //         let eventName = 'click_cta'; // Default event
  //         const lowerText = buttonText.toLowerCase();

  //         if (lowerText.includes('book your free facial')) {
  //           eventName = 'book_tour_click';
  //         } else if (lowerText.includes('full tour schedule')) {
  //           eventName = 'click_cta';
  //         }

  //         // Console Debugging
  //         console.group(`🎯 GA4 Event: ${eventName} (${buttonText})`);
  //         console.log('%cEvent:', 'color: #e74c3c; font-weight: bold;', eventName);
  //         console.log('%cText:', 'color: #e74c3c;', buttonText);
  //         console.log('%cLocation:', 'color: #e74c3c;', elementLocation);
  //         console.groupEnd();

  //         // DataLayer Push
  //         window.dataLayer.push({ ecommerce: null }); 
  //         window.dataLayer.push({
  //           event: eventName,
  //           element_text: buttonText,
  //           element_location: elementLocation
  //         });

  //         // Success Badge
  //         console.log(`%c✅ SUCCESS: GA4 "${eventName}" fired!`, 'background: #e74c3c; color: #fff; padding: 2px 5px;');

  //       } catch (err) {
  //         console.error('❌ GA4 Tour Section Buttons Error:', err);
  //       }
  //     }, true); // Capture phase ensures we grab it first
  //   });
  // }


  // ==========================================
  // 20. Process Steps 'Claim Your Spot' Tracking
  // ==========================================
  // Upgraded to querySelectorAll in case you have multiple buttons in this section
  const processClaimBtns = document.querySelectorAll('.glace-process-btn');

  if (processClaimBtns.length > 0) {
    processClaimBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        try {
          // 🛑 STOP CLASHING: Prevents generic global click trackers from logging duplicate events
          e.stopImmediatePropagation();

          const textElement = this.querySelector('.glace-process-btn-front');
          const buttonText = textElement ? textElement.innerText.trim() : this.innerText.trim();
          const elementLocation = 'process_steps';

          // Console Debugging
          console.group(`🎟️ GA4 Custom Event: book_tour_click (${buttonText})`);
          console.log('%cEvent:', 'color: #8e44ad; font-weight: bold;', 'book_tour_click');
          console.log('%cLocation:', 'color: #8e44ad;', elementLocation);
          console.groupEnd();

          // DataLayer Push
          window.dataLayer.push({ ecommerce: null }); 
          window.dataLayer.push({
            event: 'book_tour_click',
            element_text: buttonText,
            element_location: elementLocation
          });

          // Success Badge
          console.log(`%c✅ SUCCESS: GA4 "book_tour_click" (${buttonText}) fired!`, 'background: #8e44ad; color: #fff; padding: 2px 5px;');

        } catch (err) {
          console.error('❌ GA4 book_tour_click (Process Steps) Error:', err);
        }
      }, true); // Capture phase keeps it ahead of generic trackers
    });
  }


  // ==========================================
  // 21. City Schedule Carousel Tracking
  // ==========================================
  // const schedNavButtons = document.querySelectorAll('.glace-sched-nav-btn');

  // if (schedNavButtons.length > 0) {
  //   schedNavButtons.forEach(btn => {
  //     btn.addEventListener('click', function() {
  //       const action = this.classList.contains('glace-sched-next') ? 'next' : 'prev';

  //       // Small delay allows the carousel scroll animation to complete first
  //       setTimeout(() => {
  //         try {
  //           const track = document.querySelector('.glace-sched-track');
  //           const slides = document.querySelectorAll('.glace-sched-slide');

  //           if (!track || slides.length === 0) return;

  //           // Measure the width of a single card
  //           const slideWidth = slides[0].offsetWidth || 1;

  //           // Read the ACTUAL position after the track finish moving
  //           const currentPosition = Math.round(track.scrollLeft / slideWidth);

  //           // 1-based index (Card 1, Card 2, Card 3) representing the first visible card
  //           const ga4ReportingIndex = currentPosition + 1;

  //           // Console Debug Logs
  //           console.group(`🔄 GA4 Event: carousel_interact (${action})`);
  //           console.log('%cAction:', 'color: #3498db; font-weight: bold;', action);
  //           console.log('%cFirst Visible Card Index:', 'color: #2ecc71; font-weight: bold;', ga4ReportingIndex);
  //           console.groupEnd();

  //           // DataLayer Push
  //           window.dataLayer = window.dataLayer || [];
  //           window.dataLayer.push({ ecommerce: null }); 
  //           window.dataLayer.push({
  //             event: 'carousel_interact',
  //             carousel_section: 'city_schedule',
  //             carousel_action: action,
  //             carousel_index: ga4ReportingIndex
  //           });

  //           console.log(`%c✅ SUCCESS: GA4 "carousel_interact" fired at Card ${ga4ReportingIndex}`, 'background: #3498db; color: #fff; padding: 2px 5px;');

  //         } catch (err) {
  //           console.error('❌ GA4 city_schedule carousel_interact Error:', err);
  //         }
  //       }, 350); // 350ms ensures CSS smooth scroll animation has settled
  //     });
  //   });
  // }


  // ==========================================
  // 22. City Schedule Card Click Tracking
  // ==========================================
  const citySliderTrack = document.querySelector('.glace-sched-track');

  if (citySliderTrack) {
    citySliderTrack.addEventListener('click', function(e) {
      // Find the card being clicked
      const card = e.target.closest('.glace-sched-card');
      
      if (card) {
        try {
          // Dynamically get the city name
          const cityElement = card.querySelector('.glace-sched-city');
          const cityName = cityElement ? cityElement.innerText.trim() : 'Unknown City';
          const elementLocation = 'city_schedule_slider';

          // Console Debugging
          console.group(`🎟️ GA4 Custom Event: book_tour_click (${cityName})`);
          console.log('%cCity:', 'color: #d35400; font-weight: bold;', cityName);
          console.log('%cLocation:', 'color: #d35400;', elementLocation);
          console.groupEnd();

          // DataLayer Push
          window.dataLayer.push({ ecommerce: null }); 
          window.dataLayer.push({
            event: 'book_tour_click',
            element_text: cityName,
            element_location: elementLocation
          });

          // Success Badge
          console.log(`%c✅ SUCCESS: GA4 "book_tour_click" (${cityName}) fired!`, 'background: #d35400; color: #fff; padding: 2px 5px;');

        } catch (err) {
          console.error('❌ GA4 book_tour_click (City Schedule) Error:', err);
        }
      }
    }, true);
  }


  // ==========================================
  // 23. Provider Search Tracking
  // ==========================================
  const searchForm = document.getElementById('gl-search-form');
  const searchInput = document.getElementById('gl-search-input');

  if (searchForm && searchInput) {
    searchForm.addEventListener('submit', function(e) {
      try {
        const searchTerm = searchInput.value.trim();
        
        // Only fire if the search term isn't empty
        if (searchTerm !== '') {
          // Console Debugging
          console.group('🔍 GA4 Custom Event: provider_search');
          console.log('%cSearch Term:', 'color: #27ae60; font-weight: bold;', searchTerm);
          console.groupEnd();

          // DataLayer Push
          window.dataLayer.push({ ecommerce: null }); 
          window.dataLayer.push({
            event: 'provider_search',
            search_term: searchTerm,
            search_method: 'text'
          });

          // Success Badge
          console.log(`%c✅ SUCCESS: GA4 "provider_search" ("${searchTerm}") fired!`, 'background: #27ae60; color: #fff; padding: 2px 5px;');
        }
      } catch (err) {
        console.error('❌ GA4 provider_search Error:', err);
      }
    }, true);
  }


  // ==========================================
  // 24. Geolocation Search Tracking
  // ==========================================
  const locateBtn = document.getElementById('gl-locate-btn');

  if (locateBtn) {
    locateBtn.addEventListener('click', function() {
      try {
        // Console Debugging
        console.group('📍 GA4 Custom Event: provider_search (Geolocation)');
        console.log('%cSearch Method:', 'color: #3498db; font-weight: bold;', 'geolocation');
        console.groupEnd();

        // DataLayer Push
        window.dataLayer.push({ ecommerce: null }); 
        window.dataLayer.push({
          event: 'provider_search',
          search_term: '',
          search_method: 'geolocation'
        });

        // Success Badge
        console.log('%c✅ SUCCESS: GA4 "provider_search" (geolocation) fired!', 'background: #3498db; color: #fff; padding: 2px 5px;');

      } catch (err) {
        console.error('❌ GA4 provider_search (Geolocation) Error:', err);
      }
    }, true);
  }

  // ==========================================
  // 25. Search Radius Filter Tracking
  // ==========================================
  const distanceContainer = document.getElementById('gl-distance');

  if (distanceContainer) {
    distanceContainer.addEventListener('change', function(e) {
      // Check if the target is one of our radio inputs
      if (e.target.name === 'gl-radius') {
        try {
          const selectedValue = e.target.value;
          const filterValue = `${selectedValue} miles`;
          
          // Console Debugging
          console.group(`🎚️ GA4 Custom Event: search_filter (Radius)`);
          console.log('%cFilter Value:', 'color: #f1c40f; font-weight: bold;', filterValue);
          console.groupEnd();

          // DataLayer Push
          window.dataLayer.push({ ecommerce: null }); 
          window.dataLayer.push({
            event: 'search_filter',
            filter_type: 'search_radius',
            filter_value: filterValue
          });

          // Success Badge
          console.log(`%c✅ SUCCESS: GA4 "search_filter" (${filterValue}) fired!`, 'background: #f1c40f; color: #000; padding: 2px 5px;');

        } catch (err) {
          console.error('❌ GA4 search_filter (Radius) Error:', err);
        }
      }
    }, true);
  }


  // ==========================================
  // 26. Provider Card Selection Tracking
  // ==========================================
  // const resultsContainer = document.getElementById('gl-results');

  // if (resultsContainer) {
  //   resultsContainer.addEventListener('click', function(e) {
  //     // Find the closest card element that was clicked
  //     const clickedCard = e.target.closest('.card');
      
  //     if (clickedCard) {
  //       try {
  //         // Extract provider name from the card
  //         const nameElement = clickedCard.querySelector('.card__name');
  //         const providerName = nameElement ? nameElement.innerText.trim() : 'Unknown Provider';
  //         const source = 'card';

  //         // Console Debugging
  //         console.group(`📍 GA4 Custom Event: provider_select (${providerName})`);
  //         console.log('%cProvider:', 'color: #8e44ad; font-weight: bold;', providerName);
  //         console.groupEnd();

  //         // DataLayer Push
  //         window.dataLayer.push({ ecommerce: null }); 
  //         window.dataLayer.push({
  //           event: 'provider_select',
  //           provider_name: providerName,
  //           source: source
  //         });

  //         // Success Badge
  //         console.log(`%c✅ SUCCESS: GA4 "provider_select" (${providerName}) fired!`, 'background: #8e44ad; color: #fff; padding: 2px 5px;');

  //       } catch (err) {
  //         console.error('❌ GA4 provider_select Error:', err);
  //       }
  //     }
  //   }, true);
  // }


  // ==========================================
  // 31. Tour Promo Carousel Navigation Tracking
  // ==========================================
  const tourNavButtons = document.querySelectorAll('.tour-nav-btn');

  if (tourNavButtons.length > 0) {
    tourNavButtons.forEach(btn => {
      // Use capture phase (true) to intercept the action cleanly
      btn.addEventListener('click', function() {
        try {
          const action = this.classList.contains('tour-next') ? 'next' : 'prev';
          const slides = document.querySelectorAll('.tour-slide');
          
          if (slides.length === 0) return;

          // 1. Determine Current Index
          // Looks for standard active classes, fallback to checking which slide is visible
          let currentIndex = 0;
          slides.forEach((slide, index) => {
            if (
              slide.classList.contains('is-active') || 
              slide.classList.contains('active') || 
              slide.style.display === 'block' ||
              slide.getAttribute('aria-hidden') === 'false'
            ) {
              currentIndex = parseInt(slide.getAttribute('data-index')) || index;
            }
          });

          // 2. Calculate Index After Move
          const totalSlides = slides.length;
          const newIndex = (action === 'next') 
            ? (currentIndex + 1) % totalSlides 
            : (currentIndex - 1 + totalSlides) % totalSlides;

          // Console Debugging
          console.group(`🔄 GA4 Custom Event: carousel_interact (Tour Promo)`);
          console.log('%cAction:', 'color: #e67e22; font-weight: bold;', action);
          console.log('%cNew Index:', 'color: #e67e22;', newIndex);
          console.groupEnd();

          // DataLayer Push
          window.dataLayer.push({ ecommerce: null }); 
          window.dataLayer.push({
            event: 'carousel_interact',
            carousel_section: 'tour_promo',
            carousel_action: action,
            carousel_index: newIndex
          });

          // Success Badge
          console.log(`%c✅ SUCCESS: GA4 "carousel_interact" (${action}) fired!`, 'background: #e67e22; color: #fff; padding: 2px 5px;');

        } catch (err) {
          console.error('❌ GA4 tour_promo carousel_interact Error:', err);
        }
      }, true);
    });
  }


  // ==========================================
  // 32. Tour Promo CTA Button Click Tracking
  // ==========================================
  // const tourPromoSection = document.querySelector('.glace-tour-wrapper');

  // if (tourPromoSection) {
  //   tourPromoSection.addEventListener('click', function(e) {
  //     // Find the specific button element in the content column
  //     const ctaBtn = e.target.closest('.tour-content-col .btn-barrel');
      
  //     if (ctaBtn) {
  //       try {
  //         // Read text dynamically from the front span or falling back to raw inner text
  //         const frontText = ctaBtn.querySelector('.btn-barrel-text-front');
  //         const elementText = frontText ? frontText.innerText.trim() : ctaBtn.innerText.trim();
          
  //         // Verify it matches your expected CTA to filter out secondary buttons if needed
  //         if (elementText.toLowerCase().includes('book your free facial')) {
            
  //           // Console Debugging
  //           console.group('🎟️ GA4 Primary Conversion: book_tour_click');
  //           console.log('%cCTA Text:', 'color: #9b59b6; font-weight: bold;', elementText);
  //           console.log('%cDestination:', 'color: #7f8c8d;', ctaBtn.getAttribute('href'));
  //           console.groupEnd();

  //           // DataLayer Push
  //           window.dataLayer.push({ ecommerce: null }); 
  //           window.dataLayer.push({
  //             event: 'book_tour_click',
  //             element_text: 'Book your free Facial',
  //             element_location: 'tour_promo'
  //           });

  //           // Success Badge
  //           console.log('%c✅ SUCCESS: GA4 "book_tour_click" conversion fired!', 'background: #9b59b6; color: #fff; padding: 2px 5px;');
  //         }
  //       } catch (err) {
  //         console.error('❌ GA4 book_tour_click Error:', err);
  //       }
  //     }
  //   }, true); // Enabled capture phase to handle dynamic layout setups safely
  // }


  // ==========================================
  // 33. Tour Promo Schedule Button Click Tracking
  // ==========================================
  const tourContentCol = document.querySelector('.tour-content-col');

  if (tourContentCol) {
    tourContentCol.addEventListener('click', function(e) {
      // Find the button element
      const scheduleBtn = e.target.closest('.btn-barrel');
      
      if (scheduleBtn) {
        try {
          // Read text dynamically from the visible front span layer
          const frontText = scheduleBtn.querySelector('.btn-barrel-text-front');
          const elementText = frontText ? frontText.innerText.trim() : scheduleBtn.innerText.trim();
          
          // Verify it matches the Schedule text layout specifically
          if (elementText.toLowerCase().includes('full tour schedule')) {
            
            // 🛑 STOP CLASHING: Prevents the generic tracker at line 699 from firing!
            e.stopImmediatePropagation();
            e.stopPropagation();

            // Console Debugging
            console.group('📅 GA4 Event: click_cta (Tour Schedule)');
            console.log('%cCTA Text:', 'color: #2980b9; font-weight: bold;', elementText);
            console.log('%cDestination:', 'color: #7f8c8d;', scheduleBtn.getAttribute('href'));
            console.groupEnd();

            // DataLayer Push
            window.dataLayer.push({ ecommerce: null }); 
            window.dataLayer.push({
              event: 'click_cta',
              element_text: 'Full tour Schedule',
              element_location: 'tour_promo'
            });

            // Success Badge
            console.log('%c✅ SUCCESS: GA4 "click_cta" (Schedule) fired cleanly!', 'background: #2980b9; color: #fff; padding: 2px 5px;');
          }
        } catch (err) {
          console.error('❌ GA4 click_cta (Schedule) Error:', err);
        }
      }
    }, true);
  }


  // ==========================================
  // 34. Tour Promo Footer CTA Button Tracking
  // ==========================================
  const tourPromoFooter = document.querySelector('.glace-promo-footer');

  if (tourPromoFooter) {
    tourPromoFooter.addEventListener('click', function(e) {
      // Find the specific button element in the footer container
      const footerBtn = e.target.closest('.promo-footer-right .btn-barrel');
      
      if (footerBtn) {
        try {
          // Read text dynamically from the front span layer
          const frontText = footerBtn.querySelector('.btn-barrel-text-front');
          const elementText = frontText ? frontText.innerText.trim() : footerBtn.innerText.trim();
          
          // Verify it matches the target footer CTA
          if (elementText.toLowerCase().includes('see tour dates')) {
            
            // 🛑 STOP CLASHING: Prevents generic global click trackers from creating duplicates
            e.stopImmediatePropagation();
            e.stopPropagation();

            // Console Debugging
            console.group('🎟️ GA4 Primary Conversion: book_tour_click (Footer)');
            console.log('%cCTA Text:', 'color: #27ae60; font-weight: bold;', elementText);
            console.log('%cLocation:', 'color: #27ae60;', 'tour_promo_footer');
            console.groupEnd();

            // DataLayer Push
            window.dataLayer.push({ ecommerce: null }); 
            window.dataLayer.push({
              event: 'book_tour_click',
              element_text: 'See Tour Dates & Register',
              element_location: 'tour_promo_footer'
            });

            // Success Badge
            console.log('%c✅ SUCCESS: GA4 "book_tour_click" (Footer) fired cleanly!', 'background: #27ae60; color: #fff; padding: 2px 5px;');
          }
        } catch (err) {
          console.error('❌ GA4 book_tour_click (Footer) Error:', err);
        }
      }
    }, true); // Enabled capture phase to intercept before generic scripts execute
  }

  // ==========================================
  // 36. Hero State Pills Click Tracking (Updated for Smooth Scroll)
  // ==========================================
  const heroTagsContainer = document.querySelector('.hero-content-tags');

  if (heroTagsContainer) {
    heroTagsContainer.addEventListener('click', function(e) {
      const statePill = e.target.closest('.city-scroll-tag');

      if (statePill) {
        try {
          const stateName = statePill.getAttribute('data-city-name') || statePill.innerText.trim();

          if (stateName) {
            // Note: Removed stopImmediatePropagation so custom JS smooth scroll still receives the event!

            // Console Debugging
            console.group('📍 GA4 Event: click_cta (Hero State Pill)');
            console.log('%cState Name:', 'color: #e67e22; font-weight: bold;', stateName);
            console.log('%cLocation:', 'color: #e67e22;', 'hero_state_pills');
            console.groupEnd();

            // DataLayer Push
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
              event: 'click_cta',
              element_text: stateName,
              element_location: 'hero_state_pills'
            });

            // Success Badge
            console.log(`%c✅ SUCCESS: GA4 "click_cta" (${stateName}) fired cleanly!`, 'background: #e67e22; color: #fff; padding: 2px 5px;');
          }
        } catch (err) {
          console.error('❌ GA4 click_cta (Hero State Pill) Error:', err);
        }
      }
    }, false); // Set to false (bubble phase) so smooth scroll handles smoothly
  }

    // ==========================================
    // 37. Tour Locations Table "Register Now" Clicks
    // ==========================================
    document.addEventListener('click', function(e) {
        // 1. Check if the clicked element is our table button
        const registerBtn = e.target.closest('.glace-loc-btn');

        if (registerBtn) {
            // 2. Ignore disabled ("Sold Out") buttons completely
            if (registerBtn.classList.contains('glace-loc-btn--disabled')) {
                return; 
            }

            try {
            // 3. Traverse up the DOM to find the specific row and card wrapper
            const parentRow = registerBtn.closest('tr');
            const parentCard = registerBtn.closest('.glace-loc-city-card');

            if (parentRow && parentCard) {
            // 4. Extract data cleanly from the DOM elements
            const stateTitleEl = parentCard.querySelector('.glace-loc-city-title');
            const stateName = stateTitleEl ? stateTitleEl.innerText.trim() : 'Unknown State';

            const dateEl = parentRow.querySelector('.glace-loc-date');
            const tourDate = dateEl ? dateEl.innerText.trim() : 'Unknown Date';

            const venueEl = parentRow.querySelector('.glace-loc-venue');
            const tourVenue = venueEl ? venueEl.innerText.trim() : 'Unknown Venue';

            const textEl = registerBtn.querySelector('.glace-loc-btn-front');
            const elementText = textEl ? textEl.innerText.trim() : registerBtn.innerText.trim();
          
            // Save context globally for the Servicify popup to read later
            window._glaceTourContext = {
                element_location: stateName,
                tour_venue: tourVenue,
                tour_date: tourDate
            };

            // Console Debugging
            console.group('🎟️ GA4 Primary Conversion: book_tour_click (Locations Table)');
            console.log('%cCTA Text:', 'color: #27ae60; font-weight: bold;', elementText);
            console.log('%cLocation (State):', 'color: #27ae60;', stateName);
            console.log('%cVenue:', 'color: #2980b9;', tourVenue);
            console.log('%cDate:', 'color: #2980b9;', tourDate);
            console.groupEnd();

            // DataLayer Push
            window.dataLayer.push({ ecommerce: null }); 
            window.dataLayer.push({
                event: 'book_tour_click',
                element_text: elementText,
                element_location: stateName,
                tour_venue: tourVenue,
                tour_date: tourDate
            });

            // Success Badge
            console.log('%c✅ SUCCESS: GA4 "book_tour_click" (Table) fired cleanly!', 'background: #27ae60; color: #fff; padding: 2px 5px;');
            }
        } catch (err) {
            console.error('❌ GA4 book_tour_click (Table) Error:', err);
        }
        }
    }, false); // Set to bubble phase (false) and intentionally no stopPropagation() so the Servicify modal still opens!

    // ==========================================
    // 38. Servicify Popup Time Slot Selection
    // ==========================================
    document.addEventListener('click', function(e) {
        // Look for the styled-component classes Servicify uses
        const timeSlotBtn = e.target.closest('.sc-fHjqPf, .Owisg');

        if (timeSlotBtn) {
            const timeSlotText = timeSlotBtn.innerText.trim();
            
            // Updated Regex: Checks if the string contains a standard "HH:MM" pattern.
            // This naturally catches "9:00 AM", "14:30", and ranges like "09:00 - 09:15".
            const isTimeFormat = /\d{1,2}:\d{2}/.test(timeSlotText);

            if (isTimeFormat) {
                try {
                    // Read from the global context set during the Register Now click
                    const context = window._glaceTourContext || {};
                    const tourVenue = context.tour_venue || 'Unknown Venue';
                    const tourDate = context.tour_date || 'Unknown Date';
                    const stateLocation = context.element_location || 'Unknown State';

                    // Console Debugging
                    console.group('⏱️ GA4 Event: tour_time_select');
                    console.log('%cTime Slot:', 'color: #f39c12; font-weight: bold;', timeSlotText);
                    console.log('%cLocation:', 'color: #f39c12;', stateLocation);
                    console.log('%cVenue:', 'color: #2980b9;', tourVenue);
                    console.log('%cDate:', 'color: #2980b9;', tourDate);
                    console.groupEnd();

                    window._glaceTourContext = window._glaceTourContext || {};
                    window._glaceTourContext.tour_time_slot = timeSlotText;

                    // DataLayer Push
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ ecommerce: null });
                    window.dataLayer.push({
                        event: 'tour_time_select',
                        tour_venue: tourVenue,
                        tour_date: tourDate,
                        tour_time_slot: timeSlotText,
                        element_location: stateLocation
                    });

                    // Success Badge
                    console.log('%c✅ SUCCESS: GA4 "tour_time_select" fired cleanly!', 'background: #f39c12; color: #fff; padding: 2px 5px;');
                } catch (err) {
                    console.error('❌ GA4 tour_time_select Error:', err);
                }
            }
        }
    }, false);

    // ==========================================
    // 39. Servicify Popup Booking Complete (React-Proofed)
    // ==========================================
    document.addEventListener('click', function(e) {
        // 1. Target the specific Servicify confirm button
        const confirmBtn = e.target.closest('button[data-servicify="confirm-no-checkout-booking-button"]');

        if (confirmBtn) {
        // 2. Fallback check just in case they add the disabled attribute back later
        if (confirmBtn.disabled || confirmBtn.hasAttribute('disabled')) {
            return;
        }

        // 3. Manual Validation Check
        // Look for the modal wrapper to verify fields aren't blank to prevent false positives
        const modal = confirmBtn.closest('.Servicify-NoCheckout-Modal');
        if (modal) {
            const emailInput = modal.querySelector('input[name="email"]');
            const fNameInput = modal.querySelector('input[name="first-name"]');
            const phoneInput = modal.querySelector('input[type="tel"]');

            // If core fields exist but are completely empty, React will throw an error and block the submit.
            // We shouldn't track this click as a conversion!
            if ((emailInput && !emailInput.value.trim()) || 
                (fNameInput && !fNameInput.value.trim()) || 
                (phoneInput && !phoneInput.value.trim())) {
            console.warn('⚠️ GA4: Confirm clicked, but form is incomplete. Blocking false positive conversion.');
            return;
            }
        }

        try {
            // 4. Read context from the previous funnel steps
            const context = window._glaceTourContext || {};
            const tourVenue = context.tour_venue || 'Unknown Venue';
            const tourDate = context.tour_date || 'Unknown Date';
            const tourTime = context.tour_time_slot || 'Unknown Time';
            const stateLocation = context.element_location || 'Unknown State';

            // Console Debugging
            console.group('🎉 GA4 Primary Conversion: tour_booking_complete');
            console.log('%cLocation:', 'color: #16a085; font-weight: bold;', stateLocation);
            console.log('%cVenue:', 'color: #16a085;', tourVenue);
            console.log('%cDate:', 'color: #2980b9;', tourDate);
            console.log('%cTime:', 'color: #2980b9;', tourTime);
            console.groupEnd();

            // DataLayer Push
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
            event: 'tour_booking_complete',
            tour_venue: tourVenue,
            tour_date: tourDate,
            tour_time_slot: tourTime,
            element_location: stateLocation
            });

            // Success Badge
            console.log('%c✅ SUCCESS: GA4 "tour_booking_complete" fired cleanly!', 'background: #16a085; color: #fff; padding: 2px 5px;');
            
        } catch (err) {
            console.error('❌ GA4 tour_booking_complete Error:', err);
        }
        }
    }, true); // <-- SET TO TRUE: This forces the tracker to catch the click BEFORE React swallows it!

});

// ==========================================
  // 27. Map Pin Provider Selection Tracking
  // ==========================================
  // Note: This logic needs to be placed inside the function where you define your Leaflet marker click events.
function onMarkerClick(loc) {
  try {
    // DataLayer Push
    window.dataLayer.push({ ecommerce: null }); 
    window.dataLayer.push({
      event: 'provider_select',
      provider_name: loc.name, // Accessing the name from your location object
      source: 'map'
    });

    // Console Debugging
    console.log(`%c📍 GA4 Event: provider_select (Map - ${loc.name})`, 'background: #2c3e50; color: #fff; padding: 2px 5px;');
    
  } catch (err) {
    console.error('❌ GA4 provider_select (Map) Error:', err);
  }
}

// ==========================================================
// 28, 29, 30. Unified Provider Tracking (#gl-results)
// ==========================================================
// ==========================================
// Unified Provider Card & Action Tracking
// ==========================================
(function initProviderTracking() {
  const resultsContainer = document.getElementById('gl-results');
  if (!resultsContainer) return;

  resultsContainer.addEventListener('click', function(e) {
    // 1. Identify if the click happened inside a card
    const card = e.target.closest('.card');
    if (!card) return; // Ignore clicks outside of cards

    // 2. Get the provider name
    const nameElement = card.querySelector('.card__name');
    const providerName = nameElement ? nameElement.innerText.trim() : 'Unknown Provider';

    // 3. Identify specific action buttons
    const dirLink = e.target.closest('.link-directions');
    const visitBtn = e.target.closest('.btn-primary.visit');
    const phoneLink = e.target.closest('a[href^="tel:"]');

    // 4. Logic Routing (Ensure only ONE event fires per click)
    
    if (dirLink) {
      // --- Action: Get Directions ---
      console.log(`📍 GA4: provider_directions (${providerName})`);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'provider_directions',
        provider_name: providerName
      });
      
    } else if (visitBtn) {
      // --- Action: Visit Website ---
      const isDisabled = visitBtn.hasAttribute('disabled') || visitBtn.getAttribute('href') === 'null';
      if (!isDisabled) {
        console.log(`🌐 GA4: provider_website (${providerName})`);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'provider_website',
          provider_name: providerName
        });
      }
      
    } else if (phoneLink) {
      // --- Action: Phone Call ---
      console.log(`📞 GA4: provider_call (${providerName})`);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'provider_call',
        provider_name: providerName
      });
      
    } else {
      // --- Action: General Card Click (Fallback) ---
      // This ONLY fires if they click the card itself, but missed the specific buttons above
      console.group(`📍 GA4 Custom Event: provider_select (${providerName})`);
      console.log('%cProvider:', 'color: #8e44ad; font-weight: bold;', providerName);
      console.groupEnd();

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null }); 
      window.dataLayer.push({
        event: 'provider_select',
        provider_name: providerName,
        source: 'card'
      });

      console.log(`%c✅ SUCCESS: GA4 "provider_select" (${providerName}) fired!`, 'background: #8e44ad; color: #fff; padding: 2px 5px;');
    }
  }, true);
})();

// ==========================================
// 35. "Talk To A Sales Rep" Form (Shadow DOM Version)
// ==========================================
(function initShadowDomFormTracking() {
let formSubmitted = false;

function fireSalesContactEvent() {
    if (formSubmitted) return; // Prevent double firing
    formSubmitted = true;

    try {
    console.group('📩 GA4 Primary Lead Event: sales_rep_contact');
    console.log('%cLocation:', 'color: #8e44ad; font-weight: bold;', 'contact_form (Shadow DOM)');
    console.groupEnd();

    // DataLayer Push
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: 'sales_rep_contact',
        element_location: 'contact_form'
    });

    console.log('%c✅ SUCCESS: GA4 "sales_rep_contact" fired from Shadow DOM!', 'background: #8e44ad; color: #fff; padding: 2px 5px;');
    } catch (err) {
    console.error('❌ GA4 sales_rep_contact Error:', err);
    }
}

// Bind to the document body to catch the click
document.body.addEventListener('click', function(e) {
    // Use e.composedPath() to pierce the Shadow DOM and see the true elements
    const path = e.composedPath && e.composedPath();
    if (!path) return;

    let clickedSubmitBtn = null;
    let formElement = null;

    // Loop through the click path to find our button and its form
    for (let i = 0; i < path.length; i++) {
    const node = path[i];
    
    // Ensure the node is an actual HTML Element
    if (node && node.nodeType === 1) {
        
        // Look for the specific submit button data attribute
        if (node.getAttribute('data-testid') === 'btn-form-submit' || node.classList.contains('_formSubmitButton_jnbzb_106')) {
        clickedSubmitBtn = node;
        }
        
        // Look for the parent form wrapper to check validation
        if (node.tagName && node.tagName.toLowerCase() === 'form') {
        formElement = node;
        }
    }
    }

    // If we found our specific button in the click path
    if (clickedSubmitBtn) {
    // Check if the form is valid before firing
    if (formElement && typeof formElement.checkValidity === 'function') {
        if (formElement.checkValidity()) {
        fireSalesContactEvent(); // Form is valid!
        } else {
        console.warn('⚠️ GA4: Form inside Shadow DOM invalid (missing fields). Event not fired.');
        }
    } else {
        // Fallback if no <form> tag exists inside the shadow root
        fireSalesContactEvent();
    }
    }
}, true); 
})();


// ==========================================
// Tour Promo Buttons & CTA Tracking (Unified)
// ==========================================
(function initTourButtonTracking() {
  const tourWrapper = document.querySelector('.glace-tour-wrapper');
  if (!tourWrapper) return;

  tourWrapper.addEventListener('click', function(e) {
    const btn = e.target.closest('.btn-barrel');
    if (!btn) return;

    // Prevent secondary listeners from executing
    e.stopPropagation();

    try {
      const frontText = btn.querySelector('.btn-barrel-text-front');
      const buttonText = frontText ? frontText.innerText.trim() : btn.innerText.trim();
      const lowerText = buttonText.toLowerCase();
      const href = btn.getAttribute('href') || '';

      // Set exact location per tracking spec
      const location = btn.closest('[data-element-location]')?.dataset.elementLocation || 'tour_promo';

      // Event classification rule
      let eventName = 'click_cta';
      if (lowerText.includes('book') || lowerText.includes('facial') || href.includes('events.metinc.tech')) {
        eventName = 'book_tour_click';
      }

      // Console Debug Logs
      console.group(`🎯 GA4 Event: ${eventName} (${buttonText})`);
      console.log('%cText:', 'color: #9b59b6; font-weight: bold;', buttonText);
      console.log('%cLocation:', 'color: #3498db; font-weight: bold;', location);
      console.log('%cDestination:', 'color: #7f8c8d;', href);
      console.groupEnd();

      // DataLayer Push
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: eventName,
        element_text: buttonText,
        element_location: location
      });

      console.log(`%c✅ SUCCESS: GA4 "${eventName}" fired!`, 'background: #9b59b6; color: #fff; padding: 2px 5px;');

    } catch (err) {
      console.error('❌ GA4 Tour Button Tracking Error:', err);
    }
  }, true);
})();


// ==========================================
// City Schedule Carousel Tracking (Persistent)
// ==========================================
(function initScheduleCarouselTracking() {
  // Prevent duplicate binding if script runs twice
  if (window._glaceCarouselTrackingInitialized) return;
  window._glaceCarouselTrackingInitialized = true;

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.glace-sched-nav-btn');
    if (!btn) return;
    
    // Prevent false events if the button is disabled at the boundaries
    if (btn.disabled || btn.hasAttribute('disabled')) return;

    const action = btn.classList.contains('glace-sched-next') ? 'next' : 'prev';

    // Target specifically the slider we just clicked
    const sliderArea = btn.closest('.glace-sched-slider-area');
    if (!sliderArea) return;

    try {
      // Console Debugging
      console.group(`🔄 GA4 Event: carousel_interact (${action})`);
      console.log('%cAction:', 'color: #3498db; font-weight: bold;', action);
      console.groupEnd();

      // DataLayer Push (Without carousel_index)
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null }); 
      window.dataLayer.push({
        event: 'carousel_interact',
        carousel_section: 'city_schedule',
        carousel_action: action
      });

      console.log(`%c✅ SUCCESS: GA4 "carousel_interact" (${action}) fired!`, 'background: #3498db; color: #fff; padding: 2px 5px;');

    } catch (err) {
      console.error('❌ GA4 city_schedule carousel_interact Error:', err);
    }
  }, true); // Use capture phase to catch clicks reliably every single time
})();